<template>
  <div>
    <PageTitle tag="h1" class="mb-7">
      {{ $t('passReset') }}
    </PageTitle>
    <VRow>
      <VCol cols="12" sm="6" md="4" class="mx-auto mb">
        <VForm @submit.prevent="sendEmail">
          <div class="mt-sm-12 my-5">
            <VTextField
              id="login"
              v-model="login"
              type="email"
              :label="$t('email')"
              outlined
              dense
              :error-messages="errors.login"
              autocomplete="username"
              autocapitalize="none"
              hide-details
            />
          </div>
          <VRow class="flex-column" align="center" no-gutters>
            <div v-if="hasErrorMessageOnly" class="red--text text-center mb-5">
              {{ errorMessage }}
            </div>
            <VBtn
              color="success"
              dark
              elevation="0"
              type="submit"
              :loading="loading"
            >
              {{ $t('sendEmail') }}
            </VBtn>
          </VRow>
        </VForm>
        <VRow
          no-gutters
          align="center"
          justify="center"
          class="mt-5 flex-column flex-md-row body-1"
        >
          <RouterLink to="/registration" class="text-decoration-none mx-6">
            {{ $t('registration') }}
          </RouterLink>
          <RouterLink to="/login" class="text-decoration-none mx-6">
            {{ $t('login') }}
          </RouterLink>
        </VRow>
      </VCol>
    </VRow>
  </div>
</template>

<script>
import ValidationMixin from '../mixins/ValidationMixin';
import RecaptchaMixin from '../mixins/RecaptchaMixin';
import PageTitle from '../components/PageTitle.vue';
import User from '../orm/models/User/User';

export default {
  name: 'ForgotPassword',
  metaInfo() {
    return {
      title: this.$t('passReset'),
    };
  },
  components: { PageTitle },
  mixins: [ValidationMixin, RecaptchaMixin],
  data() {
    return {
      login: null,
    };
  },
  methods: {
    sendEmail() {
      this.withValidationHandling(async () => {
        const recaptchaToken = await this.getRecaptchaToken('passwordForgot');
        await User.api().forgotPassword({
          login: this.login,
          recaptchaToken,
        });
        this.$toast.info(this.$t('recoveryInfoSent'));
        await this.$router.push({ name: 'login' });
      });
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  passReset: Reset password
  email: E-mail
  sendEmail: Send e-mail
  registration: Registration
  login: Login
  recoveryInfoSent: Password recovery information was sent to your e-mail address.
</i18n>

<i18n locale="ru" lang="yaml">
  passReset: Восстановление пароля
  email: E-mail
  sendEmail: Сменить пароль
  registration: Регистрация
  login: Вход
  recoveryInfoSent: Информация для восстановления отправлена на электронную почту.
</i18n>
